import { GeolocationAdapterReturn, BGWatcherIDString } from '../types/adapters'
import { Location as BGPosition } from '@capacitor-community/background-geolocation'
export const geolocationAdapter = (): GeolocationAdapterReturn => {
  const getGPSPosition = async (
    timeout?: number,
    useStaleData?: boolean
  ): Promise<null | BGPosition> => {
    if (useStaleData) {
      console.log('Cannot use stale geolocation data in browser')
    }
    let locationReturn: null | BGPosition = null
    await getPosition(timeout)
      .then((location) => {
        const { coords } = location
        locationReturn = {
          simulated: false,
          bearing: null,
          time: location.timestamp,
          latitude: coords.latitude,
          longitude: coords.longitude,
          accuracy: coords.accuracy,
          altitude: coords.altitude,
          altitudeAccuracy: coords.altitudeAccuracy,
          speed: coords.speed,
        }
      })
      .catch((error) => console.error(error))
    return locationReturn
  }

  const getPosition = (timeout?: number): Promise<GeolocationPosition> => {
    return new Promise((resolve, reject) => {
      getPermissions()
        .then(() => {
          navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: timeout })
        })
        .catch((error) => console.error(error))
    })
  }

  const getPermissions = () => {
    return new Promise<void>((resolve, reject) => {
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then((res) => {
            const permission = res.state
            if (permission === 'granted' || permission === 'prompt') {
              resolve()
            }
          })
          .catch((error) => console.error(error))
      } else if (navigator.geolocation) {
        resolve()
      } else {
        reject()
      }
    })
  }

  let watcherID = ''
  let bgWatcher: null | any = null
  const addWatcher = async (
    getLocations: (data: BGPosition) => void,
    getWatcherID: (id: BGWatcherIDString) => void
  ) => {
    getPermissions()
      .then(
        () => {
          bgWatcher = navigator.geolocation.watchPosition((position) => {
            const { coords } = position
            const locationReturn = {
              simulated: false,
              bearing: null,
              time: position.timestamp,
              latitude: coords.latitude,
              longitude: coords.longitude,
              accuracy: coords.accuracy,
              altitude: coords.altitude,
              altitudeAccuracy: coords.altitudeAccuracy,
              speed: coords.speed,
            }
            getLocations(locationReturn)
          })
          watcherID = Date.now().toString()
          getWatcherID(watcherID)
        },
        (error) => console.error(`Error getting GPS: ${error}`)
      )
      .catch((error) => console.error(error))
  }

  const removeWatcher = (id: BGWatcherIDString) => {
    if (bgWatcher && id === watcherID) navigator.geolocation.clearWatch(bgWatcher)
  }
  return {
    addWatcher,
    removeWatcher,
    getGPSPosition,
  }
}
